import { createSlice } from "@reduxjs/toolkit";

import {
  setScrollRefBottomReducer,
  setToastDataReducer,
  userDetailsReducer,
  setUserDetailsReducer,
  setThemeReducer,
  clearUserStateReducer,
  setUserEmailReducer,
  setHasBannerReducer,
  setScrollTopValueReducer,
  setCollapsedSidebarReducer,
  toggleUpgradePremiumModalReducer,
  getStocksReducer,
  togglePremiumPlanModalReducer,
  togglePurchasePlanModalReducer,
  setLockModalReducer,
  toggleWelcomeModalReducer,
  toggleGetStartedPanelReducer,
  toggleSuggestedstrategyModalReducer,
  toggleGetStartedToggleButtonReducer,
  setShowFeatureDetailsKeyReducer,
  toggleStartGuideModalReducer,
  setMarketplaceStrategyIdReducer,
  setWalkthroughReducer,
  setWelcomeWalkthroughReducer,
  setIdleTimerReducer,
  getUserFlagsReducer,
  updateUserFlagsReducer,
  toggleCompletionModalReducer,
  toggleCreateStrategyModalReducer,
} from "./reducer";

import { SIGNUP_EMAIL_KEY, THEME_KEY, THEME_TYPES } from "utils/constants";
import { getItemFromStorage, getItemPersist } from "utils/storage";

const initialState = {
  user: null,
  scrollRefBottom: false,
  scrollTopValue: 0,
  toastData: {
    visible: false,
  },
  checkEmailModalData: {
    visible: false,
    email: "",
  },
  userEmail: getUserEmail(),
  theme: getTheme(),
  hasBanner: false,
  collapsedSidebar: false,
  showUpgradePremiumModal: false,
  stockData: [],
  isLoadingStock: false,
  showPremiumPlanModal: false,
  showPurchasePlanModal: false,
  lockModal: {
    visible: false,
    title: "UNLOCK ALL FEATURES",
    publicText: "Create an account to access all features and information",
    privateText:
      "Upgrade your account to access all premium features and tools",
  },
  inAppOnboardingGuide: {
    showWelcomeModal: false,
    showGetStartedPanel: false,
    showToggleButton: false,
    showFeatureDetailsKey: "",
    showStartGuideModal: false,
    marketplaceStrategyId: "",
    showCompletionModal: false,
    walkthrough: {
      run: false,
      stepIndex: 0,
    },
  },
  isUserIdle: false,
  userFlags: [],
  showCreateStrategyModal: false,
};

function getTheme() {
  const theme = getItemPersist(THEME_KEY);
  if (theme) {
    return theme;
  }
  return THEME_TYPES.LIGHT;
}

function getUserEmail() {
  const userEmail = getItemFromStorage(SIGNUP_EMAIL_KEY);
  return userEmail || "";
}

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setScrollRefBottom: setScrollRefBottomReducer,
    toast: setToastDataReducer,
    setUserDetails: setUserDetailsReducer,
    setTheme: setThemeReducer,
    clearUserState: clearUserStateReducer,
    setUserEmail: setUserEmailReducer,
    setHasBanner: setHasBannerReducer,
    setScrollTopValue: setScrollTopValueReducer,
    setCollapsedSidebar: setCollapsedSidebarReducer,
    toggleUpgradePremiumModal: toggleUpgradePremiumModalReducer,
    togglePremiumPlanModal: togglePremiumPlanModalReducer,
    togglePurchasePlanModal: togglePurchasePlanModalReducer,
    setLockModal: setLockModalReducer,
    toggleWelcomeModal: toggleWelcomeModalReducer,
    toggleGetStartedPanel: toggleGetStartedPanelReducer,
    toggleSuggestedstrategyModal: toggleSuggestedstrategyModalReducer,
    toggleGetStartedToggleButton: toggleGetStartedToggleButtonReducer,
    setShowFeatureDetailsKey: setShowFeatureDetailsKeyReducer,
    toggleStartGuideModal: toggleStartGuideModalReducer,
    setMarketplaceStrategyId: setMarketplaceStrategyIdReducer,
    setWalkthrough: setWalkthroughReducer,
    setWelcomeWalkthrough: setWelcomeWalkthroughReducer,
    setIdleTimer: setIdleTimerReducer,
    toggleCompletionModal: toggleCompletionModalReducer,
    toggleCreateStrategyModal: toggleCreateStrategyModalReducer,
  },
  extraReducers: (builder) => {
    userDetailsReducer(builder);
    getStocksReducer(builder);
    getUserFlagsReducer(builder);
    updateUserFlagsReducer(builder);
  },
});

export const {
  setScrollRefBottom,
  toast,
  setUserDetails,
  setWalkthrough,
  setWelcomeWalkthrough,
  setTheme,
  clearUserState,
  setUserEmail,
  setHasBanner,
  setScrollTopValue,
  setCollapsedSidebar,
  toggleUpgradePremiumModal,
  togglePremiumPlanModal,
  togglePurchasePlanModal,
  setLockModal,
  toggleWelcomeModal,
  toggleGetStartedPanel,
  toggleSuggestedstrategyModal,
  toggleGetStartedToggleButton,
  setShowFeatureDetailsKey,
  toggleStartGuideModal,
  setMarketplaceStrategyId,
  setIdleTimer,
  toggleCompletionModal,
  toggleCreateStrategyModal,
} = layoutSlice.actions;

export default layoutSlice.reducer;
